import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("coder");

export const coderTransport = transport;
export const CODER_BASE_URL = baseUrl;
